const MAX_MOBILE_WIDTH = 479
const MAX_TABLET_WIDTH = 768

export const MOBILE_MEDIA_QUERY = `@media (max-width: ${MAX_MOBILE_WIDTH}px)`
export const TABLET_MEDIA_QUERY = `@media (min-width: ${MAX_MOBILE_WIDTH + 1}px) and (max-width: ${MAX_TABLET_WIDTH}px)`
